// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__2pdiX","tab":"styles_tab__qKrWJ","activeTab":"styles_activeTab__8I-2_","tabs":"styles_tabs__MAWUW"};